import { CardPage } from './pages/CardPage'
import { DeleteAccountPage } from './pages/DeleteAccountPage'
import { HomePage } from './pages/HomePage'
import { LegalPage } from './pages/LegalPage'
import { NotFoundPage } from './pages/NotFoundPage'

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/'
  if (path === '/') return <HomePage />
  if (path === '/privacy') return <LegalPage type="privacy" />
  if (path === '/terms') return <LegalPage type="terms" />
  if (path === '/delete-account') return <DeleteAccountPage />
  const cardMatch = path.match(/^\/card\/([^/]+)$/)
  if (cardMatch) return <CardPage cardId={decodeURIComponent(cardMatch[1])} />
  return <NotFoundPage />
}
